export const debounce = (fn, wait) => {
  let timer = null;

  return function (...args) {
    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      fn.apply(this, args);
      timer = null;
    }, wait);
  };
};

export const Logger = function (debug, id) {
  if (debug) {
    return {
      log: (sender, message = null, data = null) => {
        console.log(`${id} > ${sender}${message || data ? ':' : ''}`, message || '', data || '');
      },
      timeStart: (sender, message = null) => {
        console.time(`${id} > ${sender}${message ? ':' : ''}`, message || '');
      },
      timeEnd: (sender, message = null) => {
        console.log(`----FINISHED ${new Date().toISOString()}----`);
        console.timeEnd(`${id} > ${sender}${message ? ':' : ''}`, message || '');
      },
    };
  }
  return {
    log: () => {},
    timeStart: () => {},
    timeEnd: () => {},
  };
};

export class FnRepeater {
  /**
   * Вспомогательный класс для повторного вызова функции с увеличивающимся интервалом
   * @param {Function} fn функция для повторного вызова
   * @param {int} startTimeout начальная задержка вызова
   * @param {int} maxTimeout максимальная задержка (возможно стоит заменить на repeatCount)
   */
  constructor(fn, startTimeout, maxTimeout) {
    Object.assign(this, {
      fn,
      startTimeout,
      maxTimeout,
      timer: null,
    });
  }

  /**
   * Запуск цикла повторов
   * @param {boolean} immediate вызвать сразу после старта, или после минимального таймаута
   */
  start(immediate = true) {
    this._tick(this.startTimeout, this.maxTimeout, immediate);
  }

  /**
   * Принудительная остановка повторного запуска
   */
  stop() {
    clearTimeout(this.timer);
    this.timer = null;
  }

  _tick(timeout, maxTimeout, immediate = true) {
    if (immediate) this.fn();

    if (timeout <= maxTimeout) {
      const nextTick = () => this._tick(timeout * 2, maxTimeout);
      this.timer = setTimeout(nextTick, timeout);
    } else {
      this.timer = null;
    }
  }
}
